var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"vertical":"","color":"primary"}},[_vm._l((_vm.parameterList),function(item){return _c('v-tab',{key:item.name},[_vm._v(" "+_vm._s(item.name)+" ")])}),_vm._l((_vm.parameterList),function(item){return _c('v-tab-item',{key:item.name},[_c('v-container',[_c('Table',{attrs:{"configs":item.itemparameter}})],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }